var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('ImpresoraNavar'),_c('ImpresoraBanner'),_c('ImpresoraCategorias'),_c('ImpresoraFaq'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }